export interface ITax {
  id: number;
  name: string;
  isDeleted: true;
  tax: number;
}
